import type { ComponentPropsWithoutRef } from "react";
import { Coins } from "lucide-react";

/** Shared credit icon, kept behind a local wrapper so its visual language can evolve centrally. */
export function CreditMark({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) {
  return <Coins aria-hidden="true" className={className} strokeWidth={1.7} {...props} />;
}
